import { useSelector } from 'react-redux'

import TopCategories from '../../../../components/pages/Statistics/StatisticsContent/Grids/components/TopCategories'

import { selectTopCategories } from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

const TutorDetailsClasses = () => {
  const topCategories = useSelector(selectTopCategories)

  return (
    <div className="flex-1 p-[20px] rounded-[10px] border-[1px] border-[#FFCA84] bg-[#FFF5EE] flex flex-col items-center justify-center">
      <TopCategories
        title="Classes"
        topCategories={topCategories}
        containerClassName="!w-full !bg-transparent !p-0"
        containerTitleClassName="!w-fit !px-[16px] !py-[4px]"
        doughnutWrapperClassName="w-[180px]"
        itemContainerClassName="px-[10px] py-[12px]"
        itemClassName="items-center justify-center"
        itemTitleClassName="!text-sm"
        itemTitleWrapperClassName="!ml-[12px]"
        firstCircleSize={72}
        secondCircleSize={58}
        thirdCircleSize={44}
        emptyMessage="Your Classes Will Show Here After You Take Few Classes"
      />
    </div>
  )
}

export default TutorDetailsClasses
